import "./App.css";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setTheSUBROLE,
  setTheuserStateName,
  setTheUserregionName,
  setTheUserZoneName,
  setGeoLoactionStateAction,
  setTheEmployeeeStateName,
  setTheEmployeeregionName,
  setTheEmployeeZoneName,
  seTheFilterfirstTime,
  setTheIdOne,
  getUserSuccessAction,
  settheCustomerUDSemployeeloginresponse,
  setTheUDSTOKEN,
} from "./Redux/Slice";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
  useParams,
  useLocation,
} from "react-router-dom";
import gif from "./Assets/loader.gif";
import LoginPage from "./Component/MainComponent/LoginPage/LoginPage";
import { ToastContainer } from "react-toastify";
import DashBoard from "./Component/MainComponent/DashBoard/DashBoard";
import Forgotpassword from "./Component/MainComponent/Forgotpassword/Forgotpassword";
import Verification from "./Component/MainComponent/Verify/Verification";
import ResetPassword from "./Component/MainComponent/ResetPassword/ResetPassword";
import Navbar from "./Component/AppComponent/Navbar/Navbar";
import SideBar from "./Component/AppComponent/SideBar/SideBar";
import UserDetails from "./Component/MainComponent/User/UserDetails";
import Role from "./Component/MainComponent/Role/Role";
import UserCreateForm from "./Component/MainComponent/User/UserCreateForm";
import State from "./Component/MainComponent/Geolocation/State";
import Region from "./Component/MainComponent/Geolocation/Region";
import Zone from "./Component/MainComponent/Geolocation/Zone";
import Client from "./Component/MainComponent/Client/Client";
import ClientBranches from "./Component/MainComponent/Client/ClientBranches";
import ClientBranchCreate from "./Component/MainComponent/Client/ClientBranchCreate";
import Loader from "./Component/AppComponent/Loader";
import Shift from "./Component/MainComponent/Shift/Shift";
import ShiftCreateForm from "./Component/MainComponent/Shift/ShiftCreateForm";
import Employee from "./Component/MainComponent/Employee/Employee";
import EmployeeCreate from "./Component/MainComponent/Employee/EmployeeCreate";
import SetnewPassword from "./Component/MainComponent/SetNewPassword/SetnewPassword";
import EmployeeVerify from "./Component/MainComponent/Management/EmployeeVerify";
import EmployeeList from "./Component/MainComponent/Management/EmployeeList";
import ClientDetails from "./Component/MainComponent/Client/ClientDetails";
import EMployeeProfiles from "./Component/MainComponent/EmployeeProfile/EMployeeProfiles";
import BasicForms from "./Component/MainComponent/FormDetails/BasicForms";
import AddressForm from "./Component/MainComponent/FormDetails/AddressForm";
import FormTabs from "./Component/MainComponent/FormDetails/FormTabs";
import EducationDetails from "./Component/MainComponent/FormDetails/EducationDetails";
import PreviousEmp from "./Component/MainComponent/FormDetails/PreviousEmp";
import FamilyDetails from "./Component/MainComponent/FormDetails/FamilyDetails";
import VerifyStatus from "./Component/MainComponent/EmployeeProfile/VerifyStatus";
import ExcelSheetUpload from "./Component/AppComponent/Popup/ExcelSheetUpload";
import LeaveTypeStatus from "./Component/MainComponent/LeaveType/LeaveTypeStatus";
import LeavePermission from "./Component/MainComponent/LeavePermission/LeavePermission";
import SignaturePopup from "./Component/MainComponent/User/SignaturePopup";
import Permission from "./Component/MainComponent/Client/Permission";
import { setTheDashboardactions } from "../src/Redux/Slice";
import Error401 from "./Component/AppComponent/Error401/Error401";
import ReInvestment from "./Component/MainComponent/Reinvestment/ReInvestment";
import Calender from "./Component/MainComponent/Calender/Calender";
import Onduty from "./Component/MainComponent/OnDuty/Onduty";
import Exit from "./Component/MainComponent/ExitFlow/Exit";
import Resgin from "./Component/MainComponent/Resign/Resgin";
import Nodue from "./Component/MainComponent/ExitFlow/Nodue";
import ExitClearanceList from "./Component/MainComponent/ExitWorkflow/ExitClearanceList";
import ExitCaseView from "./Component/MainComponent/ExitWorkflow/ExitCaseView";
import ExitInitiate from "./Component/MainComponent/ExitWorkflow/ExitInitiate";
import ExitMasters from "./Component/MainComponent/ExitWorkflow/ExitMasters";
import ExitBulkInitiate from "./Component/MainComponent/ExitWorkflow/ExitBulkInitiate";
import ExitRejoinForm from "./Component/MainComponent/ExitWorkflow/ExitRejoinForm";
import IdCardVerify from "./Component/MainComponent/IdCard/IdCardVerify";
import Appraisal from "./Component/MainComponent/appraisal/Appraisal";
import PaySlip from "./Component/MainComponent/PaySlip/PaySlip";
import FiedlAgent from "./Component/MainComponent/FieldAgent/FiedlAgent";
import EmployeeListManager from "./Component/MainComponent/FieldAgent/EmployeeList";
import HrinterviewForm from "./Component/MainComponent/ExitFlow/HRinterview";
import Grievence from "./Component/MainComponent/Grievence/Grievence";
import Performance from "./Component/MainComponent/Performance/Performance";
import PerformanceChild from "./Component/MainComponent/Performance/PerformanceChild";
import ManPower from "./Component/MainComponent/ManPower/ManPower";
import SheetUpload from "./Component/MainComponent/SheetUpload/SheetUpload";
import GrievaceApprove from "./Component/MainComponent/Grievence/GrievaceApprove";
import GrievanceEmployeeList from "./Component/MainComponent/Grievence/GrievanceEmployeeList";
import AttendanceRequestlists from "./Component/MainComponent/AttendanceRequestlist/AttendanceRequestlists";
import ManPowerApply from "./Component/MainComponent/ManPower/ManPowerApply";
import GrommingStandard from "./Component/MainComponent/ManPowerForms/GrommingStandard";
import BlackList from "./Component/MainComponent/Blacklist/BlackList";
import SiteTransfer from "./Component/MainComponent/SiteTransfer/SiteTransfer";
import SendNotifi from "./Component/MainComponent/SendNotifi";
import UserProfile from "./Component/MainComponent/User/UserProfile";
import AdminUserRights from "./Component/MainComponent/User/AdminUserRights";
import ActiveEmployeeList from "./Component/MainComponent/Active/ActiveEmployeeList";
import Allformcreate from "./Component/MainComponent/Allformcreate";
import Report from "./Component/MainComponent/Report/Report";
import Profile from "./Component/MainComponent/Report/Profile";
import AttendanceDash from "./Component/MainComponent/DashBoard/AttendanceDash";
import OnboardingDash from "./Component/MainComponent/DashBoard/OnboardingDash";
import Gifdesign from "./Component/MainComponent/DashBoard/Gifdesign";
import Query from "./Component/MainComponent/Querys/Query";
import SubQuerys from "./Component/MainComponent/Querys/SubQuerys";
import TrackingRecords from "./Component/MainComponent/Querys/TrackingRecords";
import Finance from "./Component/MainComponent/Finance/Finance";
import AadharValidatoins from "./Component/MainComponent/Finance/AadharValidations";
import PanValidaations from "./Component/MainComponent/Finance/PanValidaations";
import Whatsapp from "./Component/MainComponent/Finance/Whatsapp";
import Bankvalidate from "./Component/MainComponent/Finance/BankValidate";
import AttendanceRecord from "./Component/MainComponent/AttendanceReport/AttendanceRecord";
import EmployeeDashboard from "./Component/MainComponent/UDSemployee/UdsEmployeeDashboard/EmployeeDashboard";
import LoginPageUDS from "./Component/MainComponent/UDSemployee/Loginpage";
import UDSNavbar from "./Component/MainComponent/UDSemployee/UDSAppComponent/Navbar";
import SideBarUDS from "./Component/MainComponent/UDSemployee/UDSAppComponent/Sidebar";
import Attendance from "./Component/MainComponent/UDSemployee/UdsEmployeeDashboard/Attendance";
import CalenderUds from "./Component/MainComponent/UDSemployee/UdsEmployeeDashboard/Calendar";
import LeaveUDS from "./Component/MainComponent/UDSemployee/UdsEmployeeDashboard/Leave";
import LeaveApplyUDS from "./Component/MainComponent/UDSemployee/UdsEmployeeDashboard/LeaveApply";
import CheckInOut from "./Component/MainComponent/UDSemployee/UdsEmployeeDashboard/CheckOut";
import UserEmployeeList from "./Component/MainComponent/AttendanceReport/UserEmployeeList";
import ReportSheetExportDatas from "./Component/MainComponent/ReportSheetExport/ReportSheetExportDatas";
import ReportCreateSheet from "./Component/MainComponent/ReportSheetExport/ReportCreateSheet";
import UserRolesheet from "./Component/MainComponent/ReportSheetExport/UserRolesheet";
import UserProfilepart from "./Component/MainComponent/User/UserProfilepart";
import EmployeeActions from "./Component/MainComponent/Management/EmployeeActions";
import OverAllreport from "./Component/MainComponent/OverAllReport/OverAllreport";
import OverAllCreatePopup from "./Component/MainComponent/OverAllReport/OverAllCreatePopup";
import OverallReportEmployee from "./Component/MainComponent/OverAllReport/OverallReportEmployee";
import config from "./Redux/Config"; // Use this line if using configuration file
import AttendanceLocation from "./Component/MainComponent/Geolocation/AttendanceLocation";
import SupportDocumentFile from "./Component/MainComponent/EmployeeProfile/SupportDocumentFile";
import MyonboardingTab from "./Component/MainComponent/Management/MyonboardingTab";
import ApproveRequestEmployee from "./Component/MainComponent/Management/ApproveRequestEmployye";
import OverTimeRequest from "./Component/MainComponent/AttendanceRequestlist/OverTimeRequest";
import { Rejoining } from "./Component/MainComponent/EmployeeProfile/Rejoining";
import Rejections from "./Component/MainComponent/EmployeeProfile/Rejections";
import MyTickets from "./Component/MainComponent/Querys/MyTicktes";
import PaySlipEmp from "./Component/MainComponent/UDSemployee/UdsEmployeeDashboard/Salary/PaySlip/PaySlip";
import ReimbursementEMP from "./Component/MainComponent/UDSemployee/UdsEmployeeDashboard/Salary/Reimbursement/Reimbursement";
import PermissionApply from "./Component/MainComponent/UDSemployee/UdsEmployeeDashboard/PermissionApply";
import PermissionEmployee from "./Component/MainComponent/UDSemployee/UdsEmployeeDashboard/PermissionEmployee";
import { OndutyEmp } from "./Component/MainComponent/UDSemployee/UdsEmployeeDashboard/OndutyEmp";
import AttendanceRegular from "./Component/MainComponent/UDSemployee/UdsEmployeeDashboard/AttendanceRegular";
import AttendanceRegularization from "./Component/MainComponent/UDSemployee/UdsEmployeeDashboard/AttendanceRegularization";
import OverTimeRegularizationget from "./Component/MainComponent/UDSemployee/UdsEmployeeDashboard/OverTimeRegularizationget";
import UdsEmpEmplyment from "./Component/MainComponent/UDSemployee/UdsEmpEmplyment";
import EmpResign from "./Component/MainComponent/UDSemployee/UdsEmployeeDashboard/EmpResign";
import NoDueEMP from "./Component/MainComponent/UDSemployee/UdsEmployeeDashboard/Salary/NoDue/NoDue";
import GrievanceEMp from "./Component/MainComponent/UDSemployee/UdsEmployeeDashboard/Salary/Grievance/GrievanceEMp";
import { HelpDeskEMP } from "./Component/MainComponent/UDSemployee/UdsEmployeeDashboard/HelpDesk";
import TeamManagement from "./Component/MainComponent/UDSemployee/TeamManagement";
import { EmployeeAttendanceEMP } from "./Component/MainComponent/UDSemployee/EmployeeAttendance";
import { SiteTransfelistEmp } from "./Component/MainComponent/UDSemployee/SiteTransfelistEmp";
import { BlockEmployeeEmp } from "./Component/MainComponent/UDSemployee/BlockEmployeeEmp";
import { AttendanceRegularizationEmp } from "./Component/MainComponent/UDSemployee/AttendanceRegularizationEmp";
import UdsEmpProfile from "./Component/MainComponent/UDSemployee/UdsEmpProfile";
import Skillassessmentemp from "./Component/MainComponent/UDSemployee/Skillassessmentemp";
import Empskillassessments from "./Component/MainComponent/UDSemployee/Empskillassessments";
import EmpSkillassessmenforms from "./Component/MainComponent/UDSemployee/EmpSkillassessmenforms";
import Categorylist from "./Component/MainComponent/Ticketingsystem/Categories/Categorylist";
import SubCategorylits from "./Component/MainComponent/Ticketingsystem/Categories/SubCategorylits";
import TicketingList from "./Component/MainComponent/Ticketingsystem/Ticketinglist/TicketingList";
import TicketIViews from "./Component/MainComponent/Ticketingsystem/Ticketinglist/TicketIViews";
import TicketDashboard from "./Component/MainComponent/Ticketingsystem/Ticketinglist/TicketDashboard";
import UdsCategory from "./Component/MainComponent/Udsspport/CategoryofUds/UdsCategory";
import SubCategoryInternal from "./Component/MainComponent/Udsspport/CategoryofUds/SubCategoryInternal";
import UnregisterTicketlist from "./Component/MainComponent/Ticketingsystem/Ticketinglist/UnregisterTicketlist";
import Departmentlist from "./Component/MainComponent/Udsspport/Department/Departmentlist";
import InternalDashboards from "./Component/MainComponent/Udsspport/InternalDashboard/InternalDashboards";
import InnerDepartmentUsers from "./Component/MainComponent/Udsspport/Department/InnerDepartmentUsers";
import InternalTicketLIsted from "./Component/MainComponent/Udsspport/InternalDashboard/InternalTicketLIsted";
import TicketraiseforInternal from "./Component/MainComponent/Udsspport/InternalDashboard/TicketraiseforInternal.";
import InternalTicketingView from "./Component/MainComponent/Udsspport/InternalDashboard/InternalTicketingView";
import InternalDepartmentUserticketView from "./Component/MainComponent/Udsspport/InternalDashboard/InternalDepartmentUserticketView";
import InternalsView from "./Component/MainComponent/Udsspport/InternalDashboard/InternalsView";
import InternalDashboardusers from "./Component/MainComponent/Udsspport/InternalDashboard/InternalDashboardUsers";
import TicketAssigns from "./Component/MainComponent/Ticketingsystem/Ticketinglist/TicketAssigns";
import ClientTicketView from "./Component/MainComponent/Udsspport/InternalDashboard/ClientTicketView";
import TicketviewforUsers from "./Component/MainComponent/Udsspport/InternalDashboard/TicketviewforUsers";
import TicketRejections from "./Component/MainComponent/Ticketingsystem/Ticketinglist/TicketRejections";
import NearDueListed from "./Component/MainComponent/Udsspport/InternalDashboard/NearDueListed";
import NeardueClient from "./Component/MainComponent/Ticketingsystem/Ticketinglist/NeardueClient";
import SubTicket from "./Component/MainComponent/Udsspport/Subticket/SubTicket";
import SUbticketinternalview from "./Component/MainComponent/Udsspport/Subticket/SUbticketinternalview";
import SubTicketView from "./Component/MainComponent/Udsspport/Subticket/SubTicketView";
import ClientTicketslisted from "./Component/MainComponent/Ticketingsystem/Ticketinglist/ClientTickets";
import NotificationScreen from "./Component/MainComponent/User/Notificationscree";
// import { requestPermissionAndGetToken } from "./getDeviceToken";
// import Notification from "./Notification"
import AdvanceDashboard from "./Component/MainComponent/DashBoard/AdvanceReport";
import AdvanceAttendance from "./Component/MainComponent/DashBoard/AdvanceAttendance";
import CustomerSupportdash from "./Component/MainComponent/Ticketingsystem/Ticketinglist/NewDashboard/CustomerSupportdash";
import Internalsupportdashboard from "./Component/MainComponent/Udsspport/InternalDashboard/NewDashboard/Internalsupportdashboard";
import { Innergeorecords } from "./Component/MainComponent/Ticketingsystem/Ticketinglist/NewDashboard/Dashboardneeds/RegionalTab/Innergeorecords/Innergeorecords";
import Masterdashlist from "./Component/MainComponent/Master_dashboard/Masterdashlist";
import Advance_hdfcattendance from "./Component/MainComponent/DashBoard/Advance_hdfcattendance";
import ESignature from "./Component/MainComponent/E_Signature/ESignature";
import { Toaster } from "react-hot-toast";
import SheetBulkUpload from "./Component/MainComponent/SheetUpload/SheetBulkUpload";
import EmployeeBulkupload from "./Component/MainComponent/EmployeeBulkUpload/EmployeeBulkupload";
import DenaveBulkUploadPreview from "./Component/MainComponent/EmployeeBulkUpload/DenaveBulkUploadPreview";
import PageShell from "./Component/MainComponent/EmployeeOnboardingForm/PageShell";
import HrApprovalList from "./Component/MainComponent/Management/HrApprovalList";
import HrEmployeeApproval from "./Component/MainComponent/Management/HrEmployeeApproval";
import DenaveNewBulkUpload from "./Component/MainComponent/EmployeeBulkUpload/DenaveNewBulkUpload";
import DenaveBulkuploadNewPreview from "./Component/MainComponent/EmployeeBulkUpload/DenaveBulkuploadNewPreview";
import HrmsConnecttivity from "./Component/MainComponent/Management/HrmsConnecttivity";
import HrmsApproveConnectivity from "./Component/MainComponent/Management/HrmsApproveConnectivity";
import IdCardList from "./Component/MainComponent/IdCard/IdCardList";
import SmartConnect from "./Component/MainComponent/SmartConnect/SmartConnect";
import SonyBulkupload from "./Component/MainComponent/SonyBulkupload/SonyBulkupload";
import SonyBulkuploadStatus from "./Component/MainComponent/SonyBulkupload/SonyBulkuploadStatus";
import LetterOnboardingStatus from "./Component/MainComponent/SonyBulkupload/LetterOnboardingStatus";
import EmployeeEsignature from "./Component/MainComponent/E_Signature/EmployeeEsignature";
import SonyEmployeeActions from "./Component/MainComponent/Management/SonyEmployeeActions";

function App() {
  const state = useSelector((state) => state);
  const [search, setsearch] = useState("");
  const [currentPage, setCurrentPage] = useState();
  const [Token, setTokens] = useState(null);
  const [Lang, setLang] = useState(1);
  // const [Role, setRole] = useState(state.users.UserData.data.user_role.role)
  const dispatch = useDispatch();
  //console.log(state.users.UserData.data.user_role.role, "states");
  const UserData = useSelector((state) => state.users.UserData);
  const [Language, setLanuage] = useState([]);
  const [Loader1, setLoader] = useState(false);
  const [Loader2, setLoader2] = useState(false);

  const LoaderData = useSelector((state) => state.Loader);
  const LoaderData2 = useSelector((state) => state.Loader2);

  const [Error401St, setError401] = useState(false);
  const [UDSTOKEN, setUDSTOken] = useState(null);
  const UserDataUDS = useSelector(
    (state) => state.CustomUDSEMployeeLogin.CustomoginDATAs,
  );

  const UserObjectData = useSelector((state) => state.users.UserData);
  const navigate = useNavigate();
  const requiredVersion = config.requiredVersion; // For configuration file

  //  useEffect(() => {
  //   requestPermissionAndGetToken(dispatch);
  // }, []);
  // console.log(state.NeededdatasListed.Notificationfirebasetoken ,"Notificationfirebasetoken");

  // useEffect(() => {
  //   if (localStorage.getItem("loginUds") == "false") {
  //     localStorage.setItem("loginUdsEmployee", "true");
  //   } else if (localStorage.getItem("loginUdsEmployee") == "false") {
  //     localStorage.setItem("loginUds", "true");
  //   }
  // }, []);
  useEffect(() => {
    // console.log(LoaderData.isLoading);
    //console.log(UserData, "data", Token);
    if (state.CustomUDSEMployeeLogin.CustomoginDATAs.data != undefined) {
      ///  console.log(UserData.data.user_role        , "tghsdtysd");
    }
    if (UserDataUDS.session) {
      dispatch(getUserSuccessAction([]));
      // localStorage.setItem("loginUds", "true")
      // localStorage.setItem("loginUdsEmployee", "false")

      // if (localStorage.getItem("loginUdsEmployee") == "false") {
      setUDSTOken(UserDataUDS.session.token);
      // } else {
      //   setUDSTOken("");
      // }
      // console.log(state.SideBarFiles.Role.toLowerCase().includes("field agent") , "role");
    }

    // if (
    //   state.users.UserData.data != undefined &&
    //   state.users.UserData.data != null
    // ) {
    //   dispatch(setTheSUBROLE(state.users.UserData.data.sub_role));
    // }
  }, [UserDataUDS]);

  // const handleChnage = () => {

  //   const browserZoomLevel = Math.round(
  //     (window.outerWidth / window.innerWidth) * 100
  //   );
  //   const zoom = (window.innerWidth / 1820) * 100;
  //   document.body.style.zoom = `${Math.round(zoom)}%`;

  // }

  // useEffect(() => {
  //   if (state.signaturepad.SignaturePopups) {
  //     document.body.removeAttribute('style');
  //   }

  //   else {
  //     // document.body.style.setProperty('property-name', 'value');
  //     handleChnage();
  //     window.addEventListener("resize", handleChnage);

  //   }
  // }, [state.signaturepad.SignaturePopups]);

  // useEffect(() => {

  //   handleChnage(); // Call handleChnage directly

  //   window.addEventListener("resize", handleChnage); // Add event listener for resize
  //   return () => {
  //     window.removeEventListener("resize", handleChnage); // Clean up event listener on unmount
  //   };
  // }, []); // Empty

  const handleChnage = () => {
    if (window.location.href.includes("/offer-letter")) {
      if (!state.SideBarFiles.TOKEN) {
        document.body.removeAttribute("style");
      } else {
        const zoom = (window.innerWidth / 1820) * 100;
        document.body.style.zoom = `${Math.round(zoom)}%`;
      }
    }
    else if (window.location.href.includes("/employee-e-sign")) {
      if (!state.SideBarFiles.TOKEN) {
        document.body.removeAttribute("style");
      } else {
        const zoom = (window.innerWidth / 1820) * 100;
        document.body.style.zoom = `${Math.round(zoom)}%`;
      }
    }
    else if (window.location.href.includes("/employee-onboarding-form") || window.location.href.includes("/exit-rejoin-form")) {
      if (!state.SideBarFiles.TOKEN) {
        document.body.removeAttribute("style");
      } else {
        const zoom = (window.innerWidth / 1820) * 100;
        document.body.style.zoom = `${Math.round(zoom)}%`;
      }
    } else {
      const zoom = (window.innerWidth / 1820) * 100;
      document.body.style.zoom = `${Math.round(zoom)}%`;
    }
  };

  useEffect(() => {
    console.log("TOKEN:", state.SideBarFiles.TOKEN); // Check the value of the token
    if (
      state.signaturepad.SignaturePopups
      //  ||
      // !state.SideBarFiles.TOKEN
    ) {
      document.body.removeAttribute("style"); // Remove the style if the token is empty or signature pop-up is active
    } else {
      handleChnage(); // Apply zoom if token is valid
      window.addEventListener("resize", handleChnage); // Add resize listener
    }

    return () => {
      window.removeEventListener("resize", handleChnage); // Clean up on unmount
    };
  }, [state.signaturepad.SignaturePopups, state.SideBarFiles.TOKEN]); // Trigger effect on token or signature popup change

  useEffect(() => {
    handleChnage(); // Apply zoom on mount if the token is valid
    window.addEventListener("resize", handleChnage); // Add resize listener
    return () => {
      window.removeEventListener("resize", handleChnage); // Clean up on unmount
    };
  }, []); // Empty dependency array to run once on mount

  useEffect(() => {
    //console.log(LoaderData.isLoading);
    setLoader(LoaderData.isLoading);
  }, [LoaderData.isLoading]);

  useEffect(() => {
    //console.log(LoaderData.isLoading);
    setLoader2(LoaderData2.isLoading2);
  }, [LoaderData2.isLoading2]);

  useEffect(() => {
    // console.log(LoaderData.isLoading);
    //console.log(UserData, "data", Token);
    if (state.users.UserData.data != undefined) {
      if (UserData.session) {
        // localStorage.setItem("loginUdsEmployee", "true")

        // dispatch(settheCustomerUDSemployeeloginresponse([]));

        // if (localStorage.getItem("loginUds") == "false") {

        setTokens(UserData.session.token);
        // } else {
        //   setTokens("");
        // }

        // console.log(state.SideBarFiles.Role.toLowerCase().includes("field agent") , "role");
      }
    }

    if (
      state.users.UserData.data != undefined &&
      state.users.UserData.data != null
    ) {
      dispatch(setTheSUBROLE(state.users.UserData.data.sub_role));
    }
  }, [UserData]);

  // useEffect(() => {
  //   // console.log(UserData.data.user_role,"loginPerson");
  // }, []);
  useEffect(() => {
    if (!LoaderData.isLoading && Token != undefined && Token != null) {
      setError401(true);
      // const payload = {
      // count: 1,
      // };
      // dispatch(setTheDashboardactions(payload));
    } else {
      setError401(false);
    }
  }, [Token]);

  // useEffect(() => {
  //   if (
  //     localStorage.getItem("loginUds") == "false" &&
  //     localStorage.getItem("loginUdsEmployee") != "false" &&
  //     Token != "" &&
  //     Token != undefined
  //   ) {
  //     const payloads = {
  //       search: "",
  //       page_size: "",
  //       page: 1,
  //     };
  //     dispatch(setGeoLoactionStateAction(payloads));
  //   }
  // }, [UserData, Token]);

  useEffect(() => {
    if (state.users.UserData.data != undefined) {
      if (UserObjectData.session) {
        // const udsroleSelectedstate = [];
        // const zoneselact = ;
        // const regionsSelect = {};
        var udsroleSelectedstate;
        var zoneselact;
        var regionsSelect;

        if (UserObjectData.data.state_id.length > 0) {
          UserObjectData.data.state_id.map((item, index) => {
            console.log(item, "287398273");
            if (index == 0) {
              // udsroleSelectedstate.push({
              //   value: item.id,
              //   label: item.state_name,
              // });
              udsroleSelectedstate = {
                value: item.id,
                label: item.state_name,
              };
            }
          });
        }

        if (UserObjectData.data.state_id.length == 0) {
          // udsroleSelectedstate.push({ value: "", label: "All" });
          udsroleSelectedstate = { value: "", label: "ALL" };
        }

        if (UserObjectData.data.zone_id.length > 0) {
          UserObjectData.data.zone_id.map((item, index) => {
            if (index == 0) {
              // zoneselact.push({
              //   value: item.id,
              //   label: item.zone_name,
              // });
              zoneselact = {
                value: item.id,
                label: item.zone_name,
              };
            }
          });
        }

        if (UserObjectData.data.region_id.length > 0) {
          UserObjectData.data.region_id.map((item, index) => {
            // console.log(item, "23094709item");
            if (index == 0) {
              // regionsSelect.push({
              //   value: item.id,
              //   label: item.region_name,
              // });

              regionsSelect = {
                value: item.id,
                label: item.region_name,
              };
            }
          });
        }
        if (UserObjectData.data.zone_id.length == 0) {
          // zoneselact.push({ value: "", label: "All" });
          zoneselact = { value: "", label: "ALL" };
        }
        if (UserObjectData.data.region_id.length == 0) {
          // regionsSelect.push({ value: "", label: "All" });
          regionsSelect = { value: "", label: "ALL" };
        }

        // setData({
        //   ...datas,
        //   state: udsroleSelectedstate[0].value,
        //   zone: zoneselact[0].value,
        //   region: regionsSelect[0].value,
        // });

        // if (udsroleSelectedstate.value == "") {
        //   if (
        //     state.GeoState.State != undefined &&
        //     state.GeoState.State != null &&
        //     state.GeoState.State.length > 0
        //   ) {
        //     state.GeoState.State.forEach((element, index) => {
        //       if (index == 0) {
        //         udsroleSelectedstate = {
        //           value: element.id,
        //           label: element.state_name,
        //         };
        //       }
        //     });
        //   }
        // }

        // dispatch(setTheEmployeeeStateName(udsroleSelectedstate));
        dispatch(setTheuserStateName(udsroleSelectedstate));
        dispatch(setTheUserregionName(regionsSelect));

        dispatch(setTheUserZoneName(zoneselact));

        //   if( state.ClientBranchIDs.First != undefined && state.ClientBranchIDs.First == 1){

        //     dispatch(setTheEmployeeeStateName(udsroleSelectedstate)); // just the initail values
        //     dispatch(setTheEmployeeregionName(regionsSelect));
        //     dispatch(setTheEmployeeZoneName(zoneselact));
        //      dispatch(seTheFilterfirstTime(2))
        //     console.log(udsroleSelectedstate , "238749283749udsroleSelectedstate",state.ClientBranchIDs.First);

        // }
      }
      //  console.log(udsroleSelectedstate , state.ClientBranchIDs.EmployeeListState , "038742398748");
    }
  }, [UserObjectData, state.GeoState.State, state.ClientBranchIDs.First]);
  const languageOptions = [
    {
      id: 1,
      value: "English",
    },
    {
      id: 2,
      value: "Hindi",
    },
  ];
  // console.log(Language, "languages");
  const LanguageChange = (e) => {
    // console.log(e.target.value, "values in app");
    //setLanuage(e.target.value)
    setLanuage({
      ...Language,
      Language: e.target.value,
    });
    if (e.target.value == "English") {
      setLang(1);
    } else {
      setLang(0);
    }
    // console.log(Lang, "las");
  };
  const LanguageChangeuds = (e) => {
    setLanuage({
      ...Language,
      Language: e.target.value,
    });
    if (e.target.value == "English") {
      setLang(1);
    } else {
      setLang(0);
    }
  };

  useEffect(() => {
    if (state.NeededdatasListed.IDS != 3) {
      setInterval(() => {
        dispatch(setTheIdOne(3));
      }, 6900);
    }

    // if(Token == null && UDSTOKEN == null){
    if (
      !window.location.href.includes("/customudsemployee") &&
      state.SideBarFiles.UDSTOKEN == "" &&
      state.SideBarFiles.TOKEN == "" &&
      !window.location.href.includes("/setnewpassword") &&
      !window.location.href.includes("/forgotpassword") &&
      !window.location.href.includes("/verify") &&
      !window.location.href.includes("/resetpassword") &&
      !window.location.href.includes("/offer-letter") &&
      !window.location.href.includes("/employee-e-sign") &&
      !window.location.href.includes("/employee-onboarding-form") &&
      !window.location.href.includes("/exit-rejoin-form") &&
      !window.location.href.includes("/id-card-verify")
    ) {
      navigate("/");
    }

    // }

    // if(window.location.href.includes("customudsemployee")){!window.location.href.includes("/verify")
    //   navigate("/")
    // }
  }, [Token, UDSTOKEN]);

  const params = useParams();
  const location = useLocation();
  const pathname = location.pathname;

  const basePath = pathname.split("/").filter(Boolean)[0] || "";

  useEffect(() => {
    if (localStorage.getItem("websiteversion") == null) {
      localStorage.clear();
      localStorage.setItem("websiteversion", requiredVersion);
      // window.location.reload();
      if (
        (window.location.href.includes("/offer-letter") ||
          window.location.href.includes("/employee-onboarding-form") ||
          window.location.href.includes("/exit-rejoin-form") ||
          window.location.href.includes("/id-card-verify") ||
          window.location.href.includes("/employee-e-sign")) &&
        !state.SideBarFiles.TOKEN
      ) {
        window.location.href = pathname;
      } else {
        window.location.href = "/";
      }
    } else if (localStorage.getItem("websiteversion") == requiredVersion) {
    } else {
      localStorage.clear();
      // window.location.reload();
      // window.location.href = "/";
      if (
        (window.location.href.includes("/offer-letter") ||
          window.location.href.includes("/employee-onboarding-form") ||
          window.location.href.includes("/exit-rejoin-form") ||
          window.location.href.includes("/id-card-verify") ||
          window.location.href.includes("/employee-e-sign")) &&
        !state.SideBarFiles.TOKEN
      ) {
        window.location.href = pathname;
      } else {
        window.location.href = "/";
      }
    }
  }, [requiredVersion]);

  return (
    <>
      <div className="App" style={{ position: "absoulute", width: "100%" }}>
        {Loader1 && <Loader />}
        {Loader2 && <Loader />}

        {
          // localStorage.getItem("loginUds") == "false" &&

          // Token !== "" && Token !== null && Token !== undefined
          state.SideBarFiles.TOKEN != "" &&
            state.SideBarFiles.TOKEN != null &&
            state.SideBarFiles.TOKEN != undefined ? (
            <>
              <Navbar />
              <SideBar />
              {/* <Notification/> */}

              {state.SideBarFiles.SideBarNotification == true && (
                <NotificationScreen />
              )}
              <Routes>
                {/* <Route path="/Dashboard" element={<DashBoard />} /> */}
                <Route path="/" element={<DashBoard />} />

                <Route
                  path="/user"
                  element={<UserDetails setLang={setLang} Lang={Lang} />}
                ></Route>
                <Route
                  path="/designation"
                  element={
                    <Role setLang={setLang} Lang={Lang} Language={Language} />
                  }
                ></Route>
                <Route path="/usercreate" element={<UserCreateForm />}></Route>
                <Route path="/client" element={<Client />}></Route>
                <Route
                  path="/clientbranch"
                  element={<ClientBranches />}
                ></Route>
                <Route
                  path="/clientcreate"
                  element={<ClientBranchCreate />}
                ></Route>
                <Route
                  path="/clientDetails"
                  element={<ClientDetails />}
                ></Route>
                <Route path="/state" element={<State />}></Route>
                <Route path="/region" element={<Region />}></Route>
                <Route path="/zone" element={<Zone />}></Route>
                <Route path="/shift" element={<Shift />}></Route>
                <Route path="/employee" element={<Employee />}></Route>
                <Route
                  path="/employeeprofile"
                  element={<EMployeeProfiles />}
                ></Route>
                <Route
                  path="/employeedetails"
                  element={<EmployeeCreate />}
                ></Route>
                {/* <Route path="/kycVerify" element={<EmployeeVerify />}></Route> */}
                <Route
                  path="/verifyrequest"
                  element={<EmployeeVerify />}
                ></Route>

                <Route
                  path="/employeeVerifylist"
                  element={<EmployeeList />}
                ></Route>
                {/* ------FORMS--------------------------------- */}
                <Route path="/basicform" element={<BasicForms />}></Route>
                <Route path="/addressform" element={<AddressForm />}></Route>
                <Route path="/formtab" element={<FormTabs />}></Route>
                <Route path="/education" element={<EducationDetails />}></Route>
                <Route path="/Previousemp" element={<PreviousEmp />}></Route>
                <Route path="/famlis" element={<FamilyDetails />}></Route>
                <Route path="/verifystatus" element={<VerifyStatus />}></Route>

                {/* -----------Leave---Type----------------- */}
                <Route path="/leavetype" element={<LeaveTypeStatus />}></Route>
                {/* --------Leave----Permission------------- */}
                <Route
                  path="/leavepermission"
                  element={<LeavePermission />}
                ></Route>
                <Route path="/Permission" element={<Permission />}></Route>
                <Route path="/reimbursement" element={<ReInvestment />}></Route>
                <Route path="/calender" element={<Calender />}></Route>
                <Route path="/Onduty" element={<Onduty />}></Route>
                <Route path="/exit" element={<Exit />}></Route>
                <Route path="/resign" element={<Resgin />}></Route>
                <Route path="/nodue" element={<Nodue />}></Route>
                <Route path="/exit-clearance" element={<ExitClearanceList />}></Route>
                <Route path="/exit-clearance/new" element={<ExitInitiate />}></Route>
                <Route path="/exit-clearance/masters" element={<ExitMasters />}></Route>
                <Route path="/exit-clearance/bulk-initiate" element={<ExitBulkInitiate />}></Route>
                <Route path="/exit-clearance/:id" element={<ExitCaseView />}></Route>
                <Route path="/appraisal" element={<Appraisal />}></Route>
                <Route path="/paySlip" element={<PaySlip />}></Route>
                {/* <Route path="/fieldagent" element={<FiedlAgent />}></Route> */}
                {/* <Route
                  path="/managerlist"
                  element={<EmployeeListManager />}
                ></Route> */}

                <Route
                  path="/fieldagent"
                  element={<EmployeeListManager />}
                ></Route>

                <Route
                  path="/hrinterview"
                  element={<HrinterviewForm />}
                ></Route>
                <Route path="/grievance" element={<Grievence />}></Route>
                <Route path="/performance" element={<Performance />}></Route>
                <Route
                  path="/performancetype"
                  element={<PerformanceChild />}
                ></Route>
                <Route path="/manpower" element={<ManPower />}></Route>
                <Route path="/sheetupload" element={<SheetUpload />}></Route>
                <Route
                  path="/sheetbulkupload"
                  element={<SheetBulkUpload />}
                ></Route>
                <Route
                  path="/EmployeeBulkupload"
                  element={<SmartConnect />}
                ></Route>
                <Route
                  path="/smartconnectupload"
                  element={<SmartConnect />}
                ></Route>
                <Route
                  path="/denavebulkupload"
                  element={<EmployeeBulkupload />}
                ></Route>
                <Route
                  path="/denavebulkupload/preview"
                  element={<DenaveBulkUploadPreview />}
                ></Route>
                <Route
                  path="/denavebulkupload/selfonboard-preview"
                  element={<DenaveBulkuploadNewPreview />}
                ></Route>
                <Route
                  path="/sonybulkupload"
                  element={<SonyBulkupload />}
                ></Route>
                <Route
                  path="/sonybulkupload/status"
                  element={<SonyBulkuploadStatus />}
                ></Route>
                <Route
                  path="/sonybulkupload/letteronboardhistory"
                  element={<LetterOnboardingStatus />}
                ></Route>
                <Route
                  path="/sonybulkupload/preview"
                  element={<SonyBulkuploadStatus />}
                ></Route>

                <Route
                  path="/grievancelist"
                  element={<GrievanceEmployeeList />}
                ></Route>
                <Route
                  path="/attendancerequest"
                  element={<AttendanceRequestlists />}
                ></Route>
                <Route
                  path="/overtimerequest"
                  element={<OverTimeRequest />}
                ></Route>
                <Route
                  path="/manpowerperform"
                  element={<ManPowerApply />}
                ></Route>
                {/* <Route path="/manpowerapply" element={<ManPowerForm />}></Route> */}
                <Route
                  path="/assessmentrequest"
                  element={<GrommingStandard />}
                ></Route>
                <Route path="/blacklist" element={<BlackList />}></Route>
                <Route path="/sitetransfer" element={<SiteTransfer />}></Route>
                <Route path="/branchlist" element={<EmployeeVerify />}></Route>
                <Route path="/communication" element={<SendNotifi />}></Route>
                <Route path="/userprofile" element={<UserProfile />}></Route>
                <Route
                  path="/adminuserlist"
                  element={<AdminUserRights />}
                ></Route>
                <Route
                  path="/activeEmployee"
                  element={<ActiveEmployeeList />}
                ></Route>

                <Route path="/report" element={<Report />}></Route>

                <Route path="/profile" element={<Profile />}></Route>

                <Route path="/allform" element={<Allformcreate />}></Route>

                {/* <Route path="/attendanceRequest"element={<AttedanceRequestgetList />}></Route> */}
                <Route path="/attendances" element={<AttendanceDash />}></Route>
                <Route
                  path="/onboardDashboard"
                  element={<OnboardingDash />}
                ></Route>
                <Route path="/ticketcategory" element={<Query />}></Route>
                <Route
                  path="/ticketsubcategory"
                  element={<SubQuerys />}
                ></Route>
                <Route path="/tickets" element={<TrackingRecords />}></Route>
                <Route path="/validate" element={<Finance />}></Route>
                <Route
                  path="/aadharvalidate"
                  element={<AadharValidatoins />}
                ></Route>
                <Route
                  path="/panvalidate"
                  element={<PanValidaations />}
                ></Route>
                <Route path="/whatsappvalidate" element={<Whatsapp />}></Route>
                <Route path="/bankvalidate" element={<Bankvalidate />}></Route>
                <Route
                  path="/attendancereport"
                  element={<AttendanceRecord />}
                ></Route>

                <Route
                  path="/EmployeelistView"
                  element={<UserEmployeeList />}
                ></Route>

                <Route
                  path="/reportsheet"
                  element={<ReportSheetExportDatas />}
                ></Route>

                {/* <Route
                  path="/reportsheetcreate"
                  element={<ReportCreateSheet />}
                ></Route> */}

                <Route
                  path="/designationsheet"
                  element={<UserRolesheet />}
                ></Route>
                <Route
                  path="/userprofilepart"
                  element={<UserProfilepart />}
                ></Route>

                <Route
                  path="/employeeaction"
                  element={<EmployeeActions />}
                ></Route>
                <Route
                  path="/sonyemployeeaction"
                  element={<SonyEmployeeActions />}
                ></Route>

                <Route path="/validation" element={<OverAllreport />}></Route>

                <Route
                  path="/createreport"
                  element={<OverAllCreatePopup />}
                ></Route>

                <Route
                  path="/reportlist"
                  element={<OverallReportEmployee />}
                ></Route>
                <Route
                  path="/attendancelocation"
                  element={<AttendanceLocation />}
                ></Route>

                <Route
                  path="/supportdocuments"
                  element={<SupportDocumentFile />}
                ></Route>
                <Route
                  path="/myonboarding"
                  element={<MyonboardingTab />}
                ></Route>
                <Route
                  path="/hrapprovallist"
                  element={<HrApprovalList />}
                ></Route>
                <Route
                  path="/hrapprovallist/:emoloyeeId"
                  element={<HrEmployeeApproval />}
                ></Route>
                <Route
                  path="/hrmsconnectivity"
                  element={<HrmsConnecttivity />}
                ></Route>
                <Route
                  path="/hrmsconnectivity/:emoloyeeId"
                  element={<HrmsApproveConnectivity />}
                ></Route>
                <Route path="/idcard" element={<IdCardList />}></Route>

                <Route
                  path="/approverequestemp"
                  element={<ApproveRequestEmployee />}
                ></Route>
                <Route path="/rejoin" element={<Rejoining />}></Route>
                <Route path="/reject" element={<Rejections />}></Route>
                <Route path="/mytickets" element={<MyTickets />}></Route>
                <Route
                  path="/ticket_category"
                  element={<Categorylist />}
                ></Route>
                <Route
                  path="/ticket_subcategory"
                  element={<SubCategorylits />}
                ></Route>
                <Route
                  path="/ticketdashboard"
                  element={<TicketDashboard />}
                ></Route>
                <Route
                  path="/customer_support_dashboard"
                  element={<CustomerSupportdash />}
                ></Route>

                <Route path="/ticketlist" element={<TicketingList />}></Route>
                <Route path="/ticketviews" element={<TicketIViews />}></Route>

                <Route path="/udscategory" element={<UdsCategory />}></Route>

                <Route
                  path="/internalsubcategory"
                  element={<SubCategoryInternal />}
                ></Route>

                <Route
                  path="/unregisterticket"
                  element={<UnregisterTicketlist />}
                ></Route>

                <Route path="/department" element={<Departmentlist />}></Route>

                <Route
                  path="/internaldashboard"
                  element={<InternalDashboards />}
                ></Route>
                <Route
                  path="/internalinnerdepartment"
                  element={<InnerDepartmentUsers />}
                ></Route>

                <Route
                  path="/internalTicket"
                  element={<InternalTicketLIsted />}
                ></Route>
                <Route
                  path="/internalTicketCreate"
                  element={<TicketraiseforInternal />}
                ></Route>
                <Route
                  path="/internalTicketView"
                  element={<InternalTicketingView />}
                ></Route>
                <Route
                  path="/internalTicketuserlist"
                  element={<InternalDepartmentUserticketView />}
                ></Route>
                <Route
                  path="/internal_ticketview"
                  element={<InternalsView />}
                ></Route>
                <Route
                  path="/internal_ticketview/ticketreject"
                  element={<TicketRejections />}
                ></Route>

                <Route
                  path="/internal_Dashboard"
                  element={<InternalDashboardusers />}
                ></Route>
                <Route
                  path="/internal_support_dashboard"
                  element={<Internalsupportdashboard />}
                ></Route>

                <Route
                  path="/ticket_allocate"
                  element={<TicketAssigns />}
                ></Route>
                <Route
                  path="/ticket_externalview"
                  element={<ClientTicketView />}
                ></Route>

                <Route
                  path="/ticket_client_view"
                  element={<TicketviewforUsers />}
                ></Route>

                <Route
                  path="/neardue_internal"
                  element={<NearDueListed />}
                ></Route>
                <Route
                  path="/neardue_client"
                  element={<NeardueClient />}
                ></Route>
                <Route path="/sub_ticker" element={<SubTicket />}></Route>
                <Route
                  path="/sub_ticket_client_view"
                  element={<SubTicketView />}
                ></Route>

                <Route
                  path="/sub_ticket_internal_view"
                  element={<SUbticketinternalview />}
                ></Route>

                <Route
                  path="/client_ticket"
                  element={<ClientTicketslisted />}
                ></Route>
                <Route
                  path="/advance_dashboard"
                  element={<AdvanceDashboard />}
                ></Route>
                <Route
                  path="/advance_attendance"
                  element={<AdvanceAttendance />}
                ></Route>
                <Route
                  path="/advance_new_attendance"
                  element={<Advance_hdfcattendance />}
                ></Route>

                <Route path="/master_dash" element={<Masterdashlist />}></Route>

                {/* <Route path="/notification" element={<NotificationScreen />}></Route> */}
              </Routes>
            </>
          ) : //  UDSTOKEN !== "" && UDSTOKEN !== null && UDSTOKEN !== undefined
            state.SideBarFiles.UDSTOKEN != "" &&
              state.SideBarFiles.UDSTOKEN != null &&
              state.SideBarFiles.UDSTOKEN != undefined ? (
              <>
                <UDSNavbar />
                <SideBarUDS />
                <Routes>
                  <Route
                    path="/customudsdashboard"
                    element={<EmployeeDashboard />}
                  />

                  <Route path="/customattendace" element={<Attendance />} />
                  <Route path="/calender" element={<CalenderUds />} />

                  <Route path="/leave" element={<LeaveUDS />} />
                  <Route path="/leave_apply" element={<LeaveApplyUDS />} />

                  <Route path="/check_in_out" element={<CheckInOut />} />
                  <Route path="/ondutyemp" element={<OndutyEmp />} />
                  {/* <Route path="/salary" element={<Salary />} /> */}
                  <Route path="/pay_slip" element={<PaySlipEmp />} />
                  <Route
                    path="/reimbursementemp"
                    element={<ReimbursementEMP />}
                  />
                  <Route
                    path="/attendanceregularization"
                    element={<AttendanceRegular />}
                  />
                  <Route path="/resignemp" element={<EmpResign />} />
                  <Route path="/nodueemp" element={<NoDueEMP />} />
                  <Route path="/grievanceemp" element={<GrievanceEMp />} />
                  <Route path="/helpdeskemp" element={<HelpDeskEMP />} />
                  <Route path="/teamemp" element={<TeamManagement />} />
                  <Route
                    path="/empattendance"
                    element={<EmployeeAttendanceEMP />}
                  />
                  <Route
                    path="/sitetransfer_emp"
                    element={<SiteTransfelistEmp />}
                  />
                  <Route path="/block_emp" element={<BlockEmployeeEmp />} />
                  <Route
                    path="/emp_attendance"
                    element={<AttendanceRegularizationEmp />}
                  />
                  <Route path="/emp_profile" element={<UdsEmpProfile />} />

                  {/* <Route path="/regularizationpopup"element={<AttendanceRegularization/>}/> */}
                  <Route path="/employment" element={<UdsEmpEmplyment />} />
                  <Route path="/permission" element={<PermissionEmployee />} />
                  <Route
                    path="/overtimeemp"
                    element={<OverTimeRegularizationget />}
                  />
                  <Route path="/permission_apply" element={<PermissionApply />} />
                  <Route path="/assessments" element={<Skillassessmentemp />} />
                  <Route
                    path="/assessments_apply"
                    element={<Empskillassessments />}
                  />

                  <Route
                    path="/assessments_form"
                    element={<EmpSkillassessmenforms />}
                  />
                </Routes>
              </>
            ) : (
              <>
                {state.NeededdatasListed.IDS == "1" ? (
                  <div
                    id="fullScreenDiv"
                    style={{
                      width: "100%",
                      height: "100%",
                      position: "absolute",
                      top: "0px",
                      right: "0px",
                      left: "0px",
                      bottom: "0px",
                      background: "white",
                      zIndex: "99999",
                    }}
                  >
                    <div
                      className=""
                      style={{
                        width: "120px",
                        height: "120px",
                        margin: "auto",
                        position: "fixed",
                        top: "0",
                        bottom: "0",
                        left: "0",
                        right: "0",
                        borderRadius: "100%",
                        background: "white",
                      }}
                    >
                      <img
                        src={gif}
                        alt="FullScreen GIF"
                        style={{
                          width: "auto",
                          height: "auto",
                          maxWidth: "100%",
                          display: " inline-block",
                        }}
                      />
                    </div>
                  </div>
                ) : null}

                <Routes>
                  <Route
                    path="/customudsemployee"
                    languageOptions={languageOptions}
                    setLang={setLang}
                    Lang={Lang}
                    onChange={LanguageChangeuds}
                    element={<LoginPageUDS />}
                  />
                  {/* </Routes>

              <Routes> */}
                  <Route
                    path="/"
                    element={
                      <LoginPage
                        languageOptions={languageOptions}
                        setLang={setLang}
                        Lang={Lang}
                        onChange={LanguageChange}
                      />
                    }
                  ></Route>
                  <Route
                    path="/setnewpassword"
                    element={<SetnewPassword />}
                  ></Route>
                  <Route
                    path="/forgotpassword"
                    element={<Forgotpassword setLang={setLang} Lang={Lang} />}
                  ></Route>
                  <Route
                    path="/verify"
                    element={<Verification setLang={setLang} Lang={Lang} />}
                  ></Route>
                  <Route
                    path="/resetpassword"
                    element={<ResetPassword setLang={setLang} Lang={Lang} />}
                  ></Route>
                  <Route
                    path="/offer-letter/:esignatureId"
                    element={<ESignature setLang={setLang} Lang={Lang} />}
                  ></Route>
                  <Route
                    path="/employee-e-sign/:esignatureId"
                    element={<EmployeeEsignature setLang={setLang} Lang={Lang} />}
                  ></Route>
                  <Route
                    path="/employee-onboarding-form/:retriveId"
                    element={<PageShell />}
                  ></Route>
                  <Route
                    path="/exit-rejoin-form/:token"
                    element={<ExitRejoinForm />}
                  ></Route>
                  <Route
                    path="/id-card-verify/:token"
                    element={<IdCardVerify />}
                  ></Route>
                  <Route
                    path="/id-card-verify"
                    element={<IdCardVerify />}
                  ></Route>
                </Routes>
              </>
            )
        }
      </div>
      {/* {Error401St ? (
        <>
          {" "}
          {Error401St ? (
            <>
              <Error401 />
            </>
          ) : null}
          <Error401 />
        </>
      ) : null} */}
      {/* {Error401St ? (
          <>
            <Error401 />
          </>
        ) : null} */}
      <ToastContainer
        //  position="bottom-center"
        autoClose={1500}
        hideProgressBar
        to={"/verifyrequest"}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        style={{ marginTop: "50px", position: "fixed", right: "0" }}
      />
      <Toaster position="top-right" gutter={12} />

      {/* {state.signaturepad.SignaturePopups ? <SignaturePopup /> : null} */}
      {state.signaturepad.SignaturePopups ? <SignaturePopup /> : null}
      {/* // show={SignaturePopups} */}
      {/* // setShow={setSignaturePupup} */}
      {/* // ImageUrlSign={ImageUrlSign} */}
      {/* // fileName={CountingNum} */}
      {/* // setUserSignError={setUserSignError} */}
      {/* // setCountingNum={setCountingNum} */}
      {/* /> */}
      {/* ) : null} */}
    </>
  );
}

export default App;
